import { createSelector } from '@ngrx/store';

import { AppState } from '../reducers';
import { State as FooterState } from '../reducers/footer.reducer';

export const selectorState = ({ footerModule }: AppState): FooterState => footerModule;
export const selectFooterLinks = createSelector(selectorState, ({ footerLinks }: FooterState) => footerLinks);
